import { Component, HostListener } from '@angular/core';

import { FilterService } from '@beecore/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'sfe-portal';

  constructor(private filterSercice: FilterService) {

  }

  @HostListener('window:beforeunload', ['$event'])
  @HostListener('window:unload', ['$event'])
  persistData() {
    this.filterSercice.persistData();
  }
}
